import React from "react";
import BotService from "../services/botService";
import { BOT_SECRETKEY } from "../config";

interface ChatInitializerProps {
	setLoading: (loading: boolean) => void;
	setInitializedChat: (initialized: boolean) => void;
	botServiceRef: React.MutableRefObject<BotService | null>;
	openWebSocket: (streamUrl: string) => void;
}

export const initializeChat = async ({
	setLoading,
	setInitializedChat,
	botServiceRef,
	openWebSocket,
}: ChatInitializerProps) => {
	setInitializedChat(true);

	const botService = new BotService(BOT_SECRETKEY);
	botServiceRef.current = botService;

	setLoading(true);
	await botService.startConversation();

	console.log("service started");

	const rss = await botService.getStreamUrl();
	openWebSocket(rss.streamUrl);

	// Set up token refresh interval
	const refreshInterval = setInterval(async () => {
		await botService.refreshToken();
	}, 120000);

	setLoading(false);

	// Return cleanup function
	return () => {
		clearInterval(refreshInterval);
	};
};

export default initializeChat;
